export function UserIcon() {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="33" height="32" rx="3" fill="currentColor" />
      <path
        d="M16 17C18 17 21 14.5376 21 11.5C21 8.46243 18.7614 6 16 6C13.2386 6 11 8.46243 11 11.5C11 14.5376 14 17 16 17Z"
        fill="white"
      />
      <path
        d="M14.5822 18C12.6479 18 10.8328 18.9341 9.70855 20.5081C9.24098 21.1626 8.91008 21.9047 8.73558 22.69L8.43364 24.0487C8.21111 25.0501 8.97311 26 9.99892 26H22.23C23.1383 26 23.8131 25.1588 23.616 24.2721L23.3522 23.0847C23.121 22.0442 22.6372 21.0767 21.9436 20.2675C20.71 18.8283 18.9091 18 17.0136 18H14.5822Z"
        fill="white"
      />
    </svg>
  );
}
